export default __webpack_public_path__ + "static/media/stage3-level1.ac5b98de.png";